import { Injectable, OnDestroy } from "@angular/core";
import { createEle } from "@ui/cer-ui-prompt.service";

@Injectable()
export class CerDataImportClipboardService implements OnDestroy {

  constructor() {
  }

  ngOnDestroy(): void {
    this.unwireEvent();
  }

  public onFilesCallback: any;

  public wireEvent() {
    document.addEventListener('paste', (event) => this.onPaste(event));
  }

  public unwireEvent() {
    //  document.removeEventListener('paste', (event) => this.onPaste(event));
  }


  public async onPaste(event: ClipboardEvent) {
    const data = event.clipboardData;
    this.onFilesCallback(data?.files)
  }

  public async readClipboardItems(mimeTypes: string[]) {
    const files: Blob[] = [];
    const clipboardItems = await navigator.clipboard.read();
    console.log(clipboardItems.length);
    for (const clipboardItem of clipboardItems) {
      const types = clipboardItem.types;
      console.log(types);
      var mimeType = mimeTypes.find(t => types.includes(t));
      if (mimeType) {
        const file = await clipboardItem.getType(mimeType);
        if (file) {
          console.log(mimeType + ' ' + file);
          files.push(file);
        }
      }
    }
    for (const file of files) {
      console.log(file);
    }
  }
  //const files: FileList = new FileList();
  //this.onFilesCallback(files);

  // Prompt input
  public onCaptureFileChange(e: Event) {
    var input = e.target as HTMLInputElement;
    if (input?.files) {
      this.onFilesCallback(input.files);
    }
  }

  public static classHover = "cer-hover";

  public infoElement: HTMLDivElement;
  private dropEle: HTMLDivElement;
  
  public dropElementGet(srcIcons: string[], acceptExtensions: string): HTMLDivElement {
    const dropEle = createEle('div') as HTMLDivElement;
    this.dropEle = dropEle;
    dropEle.classList.add("cer-capture-group", "flex-column", ".flex-nowrap", "flex-grow");
    dropEle.addEventListener('drop', (e: DragEvent) => { this.onFilesDrop(e) });
    dropEle.addEventListener('dragover', (e: DragEvent) => { this.onCaptureDragOver(e) });
    dropEle.addEventListener('dragenter', (e: DragEvent) => { this.onCaptureDragStop(e) });
    dropEle.addEventListener('dragleave', (e: DragEvent) => { this.onCaptureDragLeave(e) });
    //dropEle.addEventListener('dragend', (e: DragEvent) => { this.onCaptureDragEnd(e) });

    const h = "<div><span class='cer-larger'>①</span> Indsæt fil via udklipholder <span class='cer-key'>Ctrl+V</span> / <span class='cer-key'>cmd⌘+V</span></div>" +
      "<div><span>eller</span></div>" +
      "<div><span class='cer-larger'>②</span> Træk og slip fil hertil</div>" +
      "<div><span>eller</span></div>" +
      "<div><span class='cer-larger'>③</span> Klik på knappen nedenfor, for at vælge fil fra mappe</div>";

    this.infoElement = createEle('div', { innerHTML: h, className: "flex-column" }, dropEle) as HTMLDivElement;
    const fileDivEle = createEle('div', { className: "cer-file-upload" }, dropEle);
    const fileLabelEle = createEle('label', { className: "cer-file-upload", attrs: { "for": "fileInput" } }, fileDivEle);
    const fileDivIconsEle = createEle('div', { className: "cer-file-upload-icons" } , fileLabelEle);  // <i class="fa fa-cloud-upload"></i> Custom Upload
    srcIcons.forEach(srcIcon => {
      createEle('img', { src: srcIcon, className: 'cer-file-upload-icon' }, fileDivIconsEle);  // <i class="fa fa-cloud-upload"></i> Custom Upload
    });
    const fileInputEle = createEle('input', { id: "fileInput", type: 'file', accept: acceptExtensions }, fileDivIconsEle);  //fileInputEle.attributes.setNamedItem("multiple"); fileInputEle.classList.add("flex-column","flex-grow");
    createEle('div',{ innerHTML: "Vælg fil"}, fileLabelEle);
    fileInputEle.addEventListener('change', (e: Event) => { this.onCaptureFileChange(e) });

    return dropEle;
  }

  private onFilesDrop(e: DragEvent) {
    const files = e.dataTransfer.files;
    if (files?.length > 0) {
      this.onFilesCallback(files);
    }
    e.preventDefault();
    e.stopPropagation();
  }

  private onCaptureDragOver(e: DragEvent) {
    this.dropEle?.classList.add(CerDataImportClipboardService.classHover);
    e.preventDefault();
    e.stopPropagation();
  }

  private onCaptureDragLeave(e: DragEvent) {
    const node = e.relatedTarget as Node;
    if ((node == null || this.dropEle == null || !this.dropEle.contains(node))) {
      this.dropEle?.classList.remove(CerDataImportClipboardService.classHover);
    }
    e.preventDefault();
    e.stopPropagation();
  }
  private onCaptureDragStop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
  }

  /*
  private onCaptureDragEnd(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
  }
  */
}
